import {Component, OnInit, HostListener, Inject} from '@angular/core';

@Component({
    selector: 'app-pp',
    templateUrl: './term-of-use.component.html'
})
export class TermOfUseComponent implements OnInit {
    constructor() {
    }

    year = new Date().getFullYear();
    ngOnInit() {
    }

}
